import AddRobotModal from 'components/RobotList/RobotListView/AddRobotModal/AddRobotModal'
import { useState } from 'react'
import { IRobotInfo } from 'utils/interfaces'

const RobotListHeader = ({
  onRobotsUpdated,
  robots,
}: {
  robots: IRobotInfo[]
  onRobotsUpdated: () => void
}) => {
  const [addingNewRobot, setAddingNewRobot] = useState(false)

  return (
    <>
      <AddRobotModal
        isOpen={addingNewRobot}
        onClose={() => setAddingNewRobot(false)}
        onSave={onRobotsUpdated}
        robots={robots}
      />
    </>
  )
}

export default RobotListHeader
